import { useTranslation } from 'react-i18next';

import floralDress from '../../assets/floral-dress.png';

export function ProductPage() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization.components.ShopTheLook',
  });

  return (
    <div className="overflow-hidden rounded-lg border bg-white shadow-sm">
      <h3 className="border-b p-4 text-lg font-medium">
        {t('productPageTitle')}
      </h3>

      <div className="p-4">
        <div className="rounded-lg bg-[#f5efe5] p-6">
          <div className="mb-4 flex justify-end">
            <div className="rounded-full bg-white px-4 py-2 text-sm font-medium">
              {t('shopTheLookBadge')}
            </div>
          </div>

          <div className="flex justify-center">
            <img
              src={floralDress}
              alt="Floral pattern dress"
              width={400}
              height={600}
              className="max-h-[400px] w-auto rounded-lg"
            />
          </div>

          <div className="mt-4 rounded-lg bg-white p-4">
            <div className="mb-2 text-sm text-gray-500">{t('breadcrumb')}</div>
            <h2 className="mb-2 text-xl font-medium">{t('productTitle')}</h2>

            <div className="mb-4 flex items-baseline">
              <span className="text-lg font-medium">{t('productPrice')}</span>
              <span className="ml-2 text-sm text-gray-500">
                {t('productInstallments')}
              </span>
            </div>

            <div className="mb-4">
              <div className="inline-block rounded-full border border-gray-200 bg-white px-4 py-1 text-sm">
                {t('appDiscount')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
